export default __webpack_public_path__ + "img/6032df3437e6aadc920fddc3927c7910.png";